'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxConnect = require('redux-connect');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _reactRedux = require('react-redux');

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

var _statistics2 = require('selectors/statistics');

var _StatisticsSelectedProjectInfo = require('components/Statistics/StatisticsSelectedProjectInfo/StatisticsSelectedProjectInfo');

var _StatisticsSelectedProjectInfo2 = _interopRequireDefault(_StatisticsSelectedProjectInfo);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectStatistics = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch,
        projectId = _ref.params.projectId;
    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadProjectInfo({ projectId: Number(projectId) })).promise);
  }
}, {
  promise: function promise(_ref2) {
    var dispatch = _ref2.store.dispatch,
        projectId = _ref2.params.projectId;
    return dispatch(statisticsActions.setProjectId({ projectId: Number(projectId) }));
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    projectInfo: (0, _statistics2.getProjectInfo)(state),
    projectInfoLoading: state.statistics.projectInfoLoading
  };
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ProjectStatistics, _Component);

  function ProjectStatistics() {
    (0, _classCallCheck3.default)(this, ProjectStatistics);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectStatistics.__proto__ || (0, _getPrototypeOf2.default)(ProjectStatistics)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectStatistics, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          projectInfo = _props.projectInfo,
          projectInfoLoading = _props.projectInfoLoading,
          component = _props.component;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_StatisticsSelectedProjectInfo2.default, {
          project: projectInfo,
          loading: projectInfoLoading,
          showChangeButton: true
        }),
        component
      );
    }
  }]);
  return ProjectStatistics;
}(_react.Component), _class2.propTypes = {
  component: _propTypes2.default.node,
  projectInfo: _propTypes2.default.object,
  projectInfoLoading: _propTypes2.default.bool
}, _class2.defaultProps = {
  projectInfo: {}
}, _temp)) || _class) || _class);
exports.default = ProjectStatistics;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/ProjectStatistics/ProjectStatistics.js
// module id = 2214
// module chunks = 1